import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { taskboardReducer } from './reducers/taskboardReducer';
import { authReducer } from './reducers/authReducer';
import { channelsReducer } from './reducers/channelsReducer';
import { organizationsReducer } from './reducers/organizationsReducer';
import { uploadReducer } from './reducers/uploadReducer';
import { playerReducer } from './reducers/playerReducer';
import { issuesReducer } from './reducers/issuesReducer';
import { subscriptionReducer } from './reducers/subscriptionReducer';
import { notificationsReducer } from './reducers/notificationsReducer';
import { notesReducer } from './reducers/notesReducer';

const rootReducer = combineReducers({
  taskboard: taskboardReducer,
  user: authReducer,
  channels: channelsReducer,
  organizations: organizationsReducer,
  subscription: subscriptionReducer,
  uploads: uploadReducer,
  player: playerReducer,
  issues: issuesReducer,
  notifications: notificationsReducer,
  notes: notesReducer,
});

const store = configureStore({
  reducer: rootReducer,
});
export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
